import { Link, useNavigate } from 'react-router-dom'

import { Box, Button, Flex, FormControl, Heading, Image, Input, Stack, Text, useMediaQuery, VStack } from '@chakra-ui/react'
import SessionStartLogo from '../../components/SessionStartLogo'

const quilmesImages = require.context('../../assets/images', true)

const PasswordSuccess = () => {
  const [isLargerThan768] = useMediaQuery('(min-width: 780px)')
  const [isLargerThan1280] = useMediaQuery('(min-width: 1367px)')

  return (
    <Box
      className='boxInvited'
      display={{ md: 'flex' }}
      justifyContent={'center'}
    >
      <Box bg='white' mx={'auto'}
        {...(isLargerThan768
          ? { width: '50%' }
          : null)}
      >
        <VStack
          alignItems={'flex-start'}
          as='form'
          autoComplete='off'
          margin= {{ md: '0 auto' }}
          padding={'3rem 1rem 2rem 1rem'}
          w={{ base: '100%', md: '63%' }}
          {...(isLargerThan1280
            ? { paddingTop: '12rem' }
            : isLargerThan768
              ? { paddingTop: '3rem' }
              : {})}
        >
          <SessionStartLogo />

          <Heading fontSize={'1.5rem'} fontWeight={'400'} paddingTop={'2rem'}>
            ¡Listo! Tu contraseña fue actualizada.
          </Heading>

          <Stack paddingTop={'1rem'} w={{ base: '100%', md: 400 }}>
            <Image
              alt='logo'
              h={'auto'}
              margin={0}
              mx={'auto'}
              objectFit='cover'
              padding={0}
              paddingTop={'1.5rem'}
              src={quilmesImages('./passwordSuccess.svg')}
              w={{ md: '75%' }}
            />
          </Stack>

          <Stack
            justifyContent='center'
            paddingTop={8}
            w={{ base: '100%', md: 400 }}
          >
            <Link to='/'>
              <Button
                _focusVisible={{ outline: 'none' }}
                type='submit'
                variant={'btn-quilmes'}
              >
                Iniciar sesión
              </Button>
            </Link>
          </Stack>
        </VStack>

      </Box>
      <Box
        alignItems={'center'}
        bgColor={'#F7F7F7'}
        justifyContent={'center'}
        w={'50%'}
        {...(isLargerThan768
          ? { margin: '0', height: '100vh' }
          : { margin: '0 auto', height: 'auto' })}
      >
        {isLargerThan768
          ? (
            <Image
              alt='logo'
              h={'auto'}
              margin={0}
              mx={'auto'}
              objectFit='cover'
              padding={0}
              paddingTop={'2.5rem'}
              src={quilmesImages('./ilustracion.svg')}
              w={{ md: '50%' }}
            />
          )
          : null}
      </Box>
    </Box>
  )
}

export default PasswordSuccess
